import { IColumns } from '../../../../components/Table'

export type SettingsRulesColumnsType = 'name' | 'createdAt' | 'actions'

export const columns: IColumns<SettingsRulesColumnsType>[] = [
  {
    id: 'name',
    label: 'RULE NAME',
  },
  {
    id: 'createdAt',
    label: 'CREATED AT',
    format: (value) =>
      value
        ? new Date(value as Date).toLocaleString('en-GB', { year: 'numeric', month: '2-digit', day: '2-digit' })
        : '-',
  },
  {
    id: 'actions',
    label: 'ACTIONS',
  },
]
